// extracted by mini-css-extract-plugin
export default {"additional-details-error":"styles_additional-details-error__EoPXE"};